import styled from 'styled-components';
import { Typ80, Typ51 } from 'dc/Typ';
import TxtField11B from 'dc/TxtField11B';
import Btn021 from 'dc/Btn021';
import Load05 from 'dc/Load05';

export const Wrapper = styled.div`
  width: 100%;
  height: auto;
  min-height: 100vh;
  margin: 0 auto;
  display: flex;
  padding-bottom: 80px;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(169.97deg, #007079 0%, #1db3d9 100%);
  @media only screen and (max-width: 600px) {
    padding: 0 16px 80px;
  }
`;

export const Title = styled(Typ80)`
  margin: 154px 0 24px;
  line-height: 72px;
  color: #fff;
  max-width: 1024px;
  text-align: center;
  @media only screen and (max-width: 600px) {
    margin: 88px 0 32px;
    line-height: 28px;
    font-size: 24px;
    text-align: left;
    width: 100%;
    max-width: 300px;
  }
`;

export const Text = styled(Typ51)`
  margin: 0 0 40px;
  text-align: center;
  width: 672px;
  color: #fff;
  @media only screen and (max-width: 600px) {
    margin: 0 0 16px;
    line-height: 24px;
    font-size: 18px;
    text-align: left;
    width: 100%;
    max-width: 300px;
  }

  a {
    color: black;
    text-decoration: underline;
  }
`;

export const SearchDropdown = styled(TxtField11B)`
  margin-bottom: 24px;
  max-width: 288px;
`;

export const Button = styled(Btn021)`
  display: ${props => (props.hidden ? 'none' : 'block')};
  margin-top: ${props => (props.noInput ? '80px' : '0')};
  background-color: ${props =>
    props.disabled ? 'rgba(38, 50, 56, 0.12)' : '#D81B61'};
  color: ${props => (props.disabled ? '#263238' : '#fff')};
  width: 100%;
  margin-bottom: 22px;
  max-width: 288px;
`;

export const Loader = styled(Load05)``;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
`;
